import { onMounted, ref, reactive, computed } from 'vue';
import { API, graphqlOperation } from 'aws-amplify';
import { Autoplay } from 'swiper';
import { useStore } from 'vuex';

import { logintest, awsNow } from '@/lib/common';
import { config } from '@/config';

import { listNewsByCompany } from '@/graphql/queries';
import { News, User } from '@/@types/d';

export const TopNewsSwiperComponentSetup = () => {
  const swiperModules = [Autoplay];
  const currentUser = ref({} as User);
  const store = useStore();

  const loggedIn = ref(false);
  const news = ref<News[]>([{id: 'a', displayFrom: 1, title: 'a'}]);
  // 値を入れて初期化しないとswiper autoplayが動作しない

  onMounted(async () => {
    logintest(initView, clearView, {user:currentUser, state:loggedIn});
  });

  const initView = () => {
    queryNews();
  };
  const clearView = () => {
    news.value = [];
  };

  // ニュース取得 query
  const queryNews = async () => {
    const n = awsNow();
    
    try {
      // 汎用ニュース（companyId="users"）を取得
      const usersNews = await fetchNewsByCompany("users", n);
      
      // 自企業のニュースを取得
      const companyNews = currentUser.value.company 
        ? await fetchNewsByCompany(currentUser.value.company, n)
        : [];
      
      // 両方のニュースを統合し、displayFromでソート（降順）
      const allNews = [...usersNews, ...companyNews];
      news.value = allNews
        .sort((a: News, b: News) => (b.displayFrom || 0) - (a.displayFrom || 0));

      // 最新のニュースタイムスタンプをStoreに保存
      const latestTimestamp = allNews.length > 0 
        ? Math.max(...allNews.map(item => item.displayFrom || 0))
        : 0;
      store.commit('setLatestNewsTimestamp', latestTimestamp);
        
    } catch (error) {
      console.error('ニュース取得エラー:', error);
      news.value = [];
      store.commit('setLatestNewsTimestamp', 0);
    }
  };

  // 指定されたcompanyIdのニュースを全件取得（nextTokenを使用してページネーション対応）
  const fetchNewsByCompany = async (companyId: string, currentTime: number): Promise<News[]> => {
    const allItems: News[] = [];
    let nextToken: string | null = null;
    
    do {
      const params = {
        companyId,
        displayFrom: { le: currentTime }, // ソートキー条件として指定
        filter: { displayTo: { ge: currentTime } }, // displayToのみフィルター条件として使用
        limit: config.NEWS_LIST_QUERYLIMIT,
        sortDirection: 'DESC' as const,
        ...(nextToken && { nextToken })
      };
      
      const res: any = await API.graphql(graphqlOperation(listNewsByCompany, params));
      
      if (res?.data?.listNewsByCompany?.items) {
        allItems.push(...res.data.listNewsByCompany.items);
        nextToken = res.data.listNewsByCompany.nextToken;
      } else {
        break;
      }
    } while (nextToken);
    
    return allItems;
  };

  const listNewsContents = computed((): News[] => {
    return news.value
      .sort((a: News, b: News) => (b.displayFrom||0) - (a.displayFrom||0))
      .slice(0, config.NEWS_TOP_ARTICLES_LEN);
  });

  return {
    swiperModules,
    listNewsContents
  };
};
